import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
const steps = ['Go through the six volumes.', 'Review the Decision Maps.', 'Use the checklists.', 'Work through the cases.', 'Test the planning tools.'];
export function Guarantee() {
  return <section className="bg-cream py-14 sm:py-20" data-id="element-158" data-mp="29eghvjviqcdm">
      <div className="mx-auto w-full max-w-2xl px-4" data-id="element-159" data-mp="29f83q2zbcvqp">
        <div className="rounded-2xl bg-white p-6 text-center ring-1 ring-navy-900/10 sm:p-9" data-id="element-160" data-mp="2edsznq7j8t9c">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gogreen-500/10" data-id="element-161" data-mp="2jbbdnv0epyo7">
            <ShieldCheckIcon className="h-7 w-7 text-gogreen-600" aria-hidden="true" data-id="element-162" data-mp="2oc8vg6hi8qp6" />
          </span>
          <h2 className="mt-4 font-display text-[26px] font-bold leading-tight text-navy-900 sm:text-3xl" data-id="element-163" data-mp="2sbrbanugybl5">
            7-day guarantee
          </h2>
          <p className="mt-3 text-[15.5px] leading-relaxed text-navy-800/80" data-id="element-164" data-mp="tziw398dapae">
            Explore Mechanics Decision Map™ for 7 days.
          </p>

          <ul className="mx-auto mt-5 max-w-sm space-y-2 text-left" data-id="element-165" data-mp="3smhumd595dtu">
            {steps.map(step => <li key={step} className="rounded-xl bg-cream px-4 py-2.5 text-[14.5px] font-medium text-navy-800/85" data-id="element-166" data-mp="3ntyaexc27kg2">
                {step}
              </li>)}
          </ul>

          <p className="mt-5 text-[14.5px] leading-relaxed text-navy-800/75" data-id="element-167" data-mp="3dupgu5l3w7u8">
            If you decide within 7 days that the system isn’t right for you, you can request a refund
            according to the terms of the guarantee.
          </p>

          <div className="mt-6" data-id="element-168" data-mp="5fpcj78i6e2p">
            <CTAButton label="Try it risk-free for 7 days" data-id="element-169" data-mp="5ew3u0pzhehx" />
          </div>
        </div>
      </div>
    </section>;
}